import React from 'react';
import { Layout, Row, Spin } from 'antd';
import { FormattedMessage } from 'react-intl';
import SettingsTemplate from 'atoms/SettingsTemplate';
import Table from 'atoms/Table';
import Card from 'atoms/Card';
import Button from 'atoms/Button';
import { BUTTON_TYPE, FETCH_POLICY, PRIVATE_ROUTE } from 'utils/constants';
import { BackArrow } from 'assets';
import InfoIcon from 'atoms/InfoIcon';
import Header from 'layout/Header';
import { useQuery } from '@apollo/client';
import { GET_FEEDBACK_TEMPLATES } from 'features/feedbacks/graphql/Queries';
import { withRouter } from 'react-router-dom';
import { ContentTitle, Content, Text, Arrow } from './AntStyled';

function NewSurvey(props) {
  const { history } = props;
  const { data, loading } = useQuery(GET_FEEDBACK_TEMPLATES, {
    variables: { where: { type: 'SURVEY' } },
    fetchPolicy: FETCH_POLICY.NETWORK_ONLY,
  });

  const Title = () => (
    <>
      <ContentTitle>
        <Arrow
          src={BackArrow}
          alt="arrow"
          onClick={() => history.push(PRIVATE_ROUTE.FEED_BACK_CURRENT)}
        />
        <InfoIcon title={<FormattedMessage id="feedback.new.surveyTitle" />} />
      </ContentTitle>
    </>
  );
  const onClickRow = (record) => ({
    onClick: () => {
      history.push({
        pathname: PRIVATE_ROUTE.SURVEY_CREATE,
        state: {
          templateData: record,
        },
      });
    },
  });

  const columns = [
    {
      dataIndex: 'spanone',
      key: 'spanone',
      className: 'no-padding mw-20',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (title) => <div className="weight-500">{title}</div>,
      width: '35%',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: '45%',
      ellipsis: true,
    },
    {
      title: 'Questions',
      dataIndex: ['questions', 'count'],
      key: 'questions',
      width: '15%',
      render: (questions) => <div className="text-center">{questions}</div>,
    },
    {
      dataIndex: 'spantwo',
      key: 'spantwo',
      className: 'no-padding mw-20',
    },
  ];

  return (
    <Layout>
      <Header title={<Title />} />
      <Content>
        <Spin spinning={loading}>
          <Row justify="center">
            <Button
              type={BUTTON_TYPE.PRIMARY}
              className="btn-no-shadow"
              onClick={() => history.push(PRIVATE_ROUTE.SURVEY_CREATE)}
              name={<FormattedMessage id="feedback.add.newSurvey" />}
            />
          </Row>
          <Row justify="center" className="or">
            OR
          </Row>
          <Card padding="16" className="card">
            <SettingsTemplate>
              <Row justify="center" className="row-text">
                <Text>
                  <FormattedMessage id="feedback.add.selectTemplateTitle" />
                </Text>
              </Row>
              <Row justify="center" className="row-table">
                <Card>
                  <Table
                    className="bb-0"
                    dataSource={data?.templateFeedbacks}
                    columns={columns}
                    height="100%"
                    onRow={onClickRow}
                  />
                </Card>
              </Row>
            </SettingsTemplate>
          </Card>
        </Spin>
      </Content>
    </Layout>
  );
}

export default withRouter(NewSurvey);
